/* 定义 预设字段类型 变量的文件 */
export const EXAMPLE = 'EXAMPLE';
export const EXAMPLE2 = 'EXAMPLE2';
export const ASKFORLEAVE = 'ASK_FOR_LEAVE';
export const OVERTIME = 'OVERTIME';
export const BUSINESS_TRIP = 'BUSINESS_TRIP';
export const GO_OUT = 'GO_OUT';
export const ABNORMAL_PUNCH = 'ABNORMAL_PUNCH';
export const EXCHANGE = 'EXCHANGE';
export const EMPLOY_APPLICATION = 'EMPLOY_APPLICATION';
export const DISMISS_APPLICATION = 'DISMISS_APPLICATION';
export const CHARGESETTLED = 'ChargeSettled';//合同管理-费用明细
export const PRICERULES = 'PriceRules';//合同管理-计价条款
export const CHARGINGITEMRULES ='chargingItemRules'; // 合同管理-收费条款
export const DISBURSEITEMLIST ='disburseItemList'; // 付款管理-付款条款
export const CONTRACTDEPOSITSETTLED = 'ContractDepositSettled'; // 合同管理 - 押金退回
export const APARTMENTSSELECTOR = 'ApartmentsSelector';//商机管理-选择房源
export const ASSETDEPOSITDETAIL = 'assetDepositDetail'; //缴费管理-押金审批
export const CONTRACTED_HOUSE = 'signApartment';  // 商机管理-签约房源
export const CUSTOMER_SELECTOR = 'customerName'; // 商机管理-选择客户
export const CRM_CROPDESCRIPTION = 'corpDescription';
export const DEPARTMENT_SELECTOR = 'department-selector'; // 用户认证-部门选择
export const CONTRACTdOCUMENTS = 'contractDocuments'; //合同管理-电子合同文档
export const ATTACHMENTS = 'attachments'; //合同管理附件
export const BRANDINFO = 'opportunityBrand';
export const APPLYADMISSION_ENTRYAPPLY = 'filterEntryApplyField'; //入园申请-入园申请表单数据筛选项
export const APPLYADMISSION_SCORE = 'scoreReviewDistribution'; //入园申请-资质评审分数表格
export const APPLYADMISSION_ADDRESS = 'address'; // 入园申请 落位房源
export const APPLYADMISSION_MULTI_ADDRESS = 'multiaddress'; // 入园申请 落位房源多选
export const APPLYADMISSION_AREA = 'area'; // 入园申请 落位房源面积
export const APPLYADMISSION_SELECT_SCORE = 'score'; // 入园申请--设置评分字段
export const BUILDING_PROFILE = 'building_profile'; // 用户档案 楼栋
export const PROJECT_PROFILE = 'project_profile'; // 用户档案 项目
export const ROOM_PROFILE = 'room_profile'; // 用户档案 楼栋
export const PROSPECTIVE_HOUSE = 'prospectiveHouse'; // 入园申请 申请入驻表单 房源多选
export const MULTI_PROSPECTIVE_HOUSE = 'multiProspectiveHouse'; // 申请入驻房源选择(多选)
export const MULTI_POSITION_HOUSE = 'multiAddress'; // 落位房源选择(多选)
export const STAGE = 'stage'; // 商机管理 商机阶段
export const CHANNEL_TYPE = 'channelType'; // 商机管理 渠道类型
export const CHANNEL_NAME = 'channelName'; // 商机管理 渠道名称
export const CHANNEL_CONTACT_NAME = 'channelContactName'; // 商机管理 渠道联系人
export const REFUND_CHARGING_DETAIL = 'refundChargingDetail'; // 缴费管理 - 退款费用明细
export const REFUND_METHOD = 'refundMethod'; // 缴费管理 - 退款方式
export const REFUND_ACCOUNT = 'refundAccount'; // 缴费管理 - 付款账户
export const PAYEE_BANK_INFO = 'payeeBankInfo'; // 缴费管理 - 退款审批 收款银行信息
export const ORDER_PRIORITY = 'order_priority'; // 工单管理 - 优先级
export const ORDER_SPACE = 'order_space'; // 工单管理-所属空间
export const CERTIFIED_GARAGE = 'CERTIFIED_GARAGE'; // 认证车库
export const EMPTY_DESCRIPTION = 'empty_description'; // 字段为空是提示
